(ns com.theplantscape.plant-web.core
  (:require
   ["@sentry/react" :as Sentry]
   ["@sentry/tracing" :refer [BrowserTracing]]
   ["logrocket" :as logrocket]
  ;; ["cldrjs" :as cldrjs]
   [clojure.edn :as edn]
   [clojure.string :as str]
   ;;[tick.core :as t]
   ;;[tick.locale-en :as tl-en]
   ;;[tick.locale-en-us :as tl-us]
   [com.theplantscape.calculate.ensemble :refer [distance-lat distance-long distance-lat-long]]
   [com.theplantscape.local-store.ensemble
    :as db
    :refer [insert-diagram-data placed-plant-eids]]
   [com.theplantscape.browser-utils.ensemble :as b]
   [com.theplantscape.plant-web.components.footer :refer [footer]]
   [com.theplantscape.plant-web.components.tailwind.sidebar :refer [sidebar]]
   [com.theplantscape.plant-web.components.tailwind.toolbars
    :refer [header-logo responsive-toolbar]]
   [com.theplantscape.plant-web.components.tiles :refer [tile]]
   [com.theplantscape.plant-web.draw.constants :refer [environment]]
   [com.theplantscape.plant-web.draw.db :refer [register-queries]]
   [com.theplantscape.plant-web.draw.events :refer [rm-ob]]
   [com.theplantscape.plant-web.draw.modals :as m]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state
            hide-modal
            pan-canvas
            reset-mouse
            set-mode
            site-page
            site-state
            toggle-debug
            toggle-sidebar]]
   [com.theplantscape.plant-web.components.hero :refer [hero-style-01]]

   [com.theplantscape.plant-web.draw.ui-form :refer [ui-form-settings]]
   [com.theplantscape.plant-web.pages.diagram.view :refer [ui-dialog]]
   [com.theplantscape.plant-web.monitoring :refer [monitor-start]]
   [com.theplantscape.plant-web.pages.login :refer [login-button]]
   [com.theplantscape.plant-web.pages.missing-page :refer [ui-page-missing]]
   [com.theplantscape.plant-web.pages.plant-calendar :refer [ui-calendar]]
   #_[com.theplantscape.plant-web.pages.polyculture
      :refer [ui-page-polycultures]]
   [com.theplantscape.plant-web.pages.polyculture.events
    :refer [polyculture-global-keys]]
   [com.theplantscape.plant-web.routes :as route]
   [datascript.core :as d]
   [reagent.core :as r]
   [reagent.dom :as dom]
   [reagent.dom.client :as rc]
   [reitit.frontend.easy :as rfe]))

(add-tap #(.dir js/document %))
(defonce schema {:tag {:db/unique :db.unique/identity}
                 :tags {:db/cardinality :db.cardinality/many}})
(defonce conn (d/create-conn schema))

(defn ui-info [text]
  [:div.flex.items-center.justify-center.pa4.bg-lightest-blue.navy
   [:svg.w1 {:data-icon "info" :viewBox "0 0 32 32" :style {:fill "currentcolor"}}
    [:title "info icon"] [:path {:d "M16 0 A16 16 0 0 1 16 32 A16 16 0 0 1 16 0 M19 15 L13 15 L13 26 L19 26 z M16 6 A3 3 0 0 0 16 12 A3 3 0 0 0 16 6"}]]
   [:span.lh-title.ml3 text]])

(defn links []
  [{:href (rfe/href :homepage) :content "Home"}
   {:href (rfe/href :diagrams) :content "Diagrams"}
   {:href (rfe/href :plant-search) :content "Search Plants"}
   {:href (rfe/href :schedule) :content "Schedule"}
   {:href (rfe/href :plant-add) :content "New Plant"}
   {:href (rfe/href :plant-lists) :content "Plant Lists"}
   #_{:href (rfe/href :settings) :content "Settings"}])

(defn sidenav-links [callback]
  (into [:ul.list-reset.flex.flex-row.md:flex-col.text-center.md:text-left
         [:li.flex.text-white.mt-4.md:mt-0.mb-2
          [header-logo callback]]]
        (map-indexed
         (fn [idx link]
           [:li.mr-3.flex-1.text-white
            {:key idx}
            [:a.block.py-1.md:py-3.pl-1.align-middle.text-gray-800.no-underline.hover:text-pink-500.border-b-2.border-gray-800.md:border-gray-900.hover:border-pink-500
             {:href (:href link)
              :on-click callback #_(swap! site-state assoc-in [:site :show-sidebar] false)}
             [:i.fas.fa-link.pr-0.md:pr-3]
             [:span.pb-1.md:pb-0.text-xs.md:text-base.text-gray-100.block.md:inline-block
              (:content link)]]])

         (links))))

(defn page-tiles []
  [:div.grid.grid-cols-2.gap-4
   [:div.w-100.ma2
    [tile {:title "Diagram" :link (rfe/href :diagrams)}]]
   [:div.w-100.ma2 [tile {:title "Add plant" :link (rfe/href :plant-add)}]]
   [:div.w-100.ma2 [tile {:title "Create list" :link (rfe/href :plant-lists)}]]
   [:div.w-100.ma2 [tile {:title "Search plants" :link (rfe/href :plant-search)}]]
   [:div.w-100.ma2 [tile {:title "Schedule" :link (rfe/href :diagrams)}]]])

(defn ^:dev/always layout [view path page-name]
  (let [online #_(r/atom true) (r/cursor site-state [:online])
        show-sidebar #_(r/atom true) (r/cursor site-state [:show-sidebar])
        ;test ui-page-polycultures
        ]
    (fn [view path page-name]
      [:div.bg-white.f3
       [:div.flex.flex-col.min-h-screen
        [:div#main.grow
         [responsive-toolbar
          [:div {:class "w-full md:w-5/5"}]
          [login-button]
          {:icon-cb toggle-sidebar}]
         [ui-dialog]
         [:div {:class (if (= page-name :homepage) "" "bg-gray-100 p-4 w-full")}
          (if view
            [:div.w-full [view path]]
            [ui-page-missing path])]
         (when @show-sidebar
           [:div {:class "w-full md:w-64 bg-gray-900 md:bg-gray-900 px-2 text-center bottom-0 md:pt-8 md:top-0 md:left-0 h-16 md:h-screen md:border-r-4 md:border-gray-600 fixed"}
            [sidebar
             {;:header [header-logo toggle-sidebar]
              :close-fn toggle-sidebar
              :links [sidenav-links toggle-sidebar]}]])]
        [:div#footer.w-full
         [footer
          {:brand {:name "theplantscape" :link "https://theplantscape.com"
                   :logo "/icons/android-chrome-512x512.png"}
           :link-blocks [{:title "Reference"
                          :children [{:link (rfe/href :plant-search) :title "Find Plant"}
                                     {:link (rfe/href :polycultures) :title "Polycultures"}]}
                         {:title "Design"
                          :children [{:link (rfe/href :polycultures) :title "Polyculture"}
                                     {:link (rfe/href :diagrams) :title "Garden"}]}
                         {:title "Social"
                          :children [{:link "https://matrix.to/#/#theplantscape.com:matrix.org" :title "Chat"}
                                     {:link "https://fo.llow.social/u/olymk2@mastodon.social" :title "Masterdon"}]}]}]]]])))

(defn ui-page-settings [{:keys [path-params] :as route}]
  [:<> [ui-form-settings]])

(defonce root-element (rc/create-root (js/document.getElementById "app-body")))
(defonce root-header (rc/create-root (.-head js/document)))

(defn update-attributes 
  "Given an element and a hashmap set attributes on element from hashmap"
  [element values]
  (when (map? values)
    (reduce-kv (fn [e attr value]
                 (.setAttribute e attr value)
                 e)
               element
               values)))

(defn create-element
  "Create an element with the given id with tagname and hashmap attributes"
  [id v]
  (let [element (.createElement js/document (name (first v)))]
    (when (string? (last v))
      (update-attributes element {"id" (name id)} )
      (set! (.-innerHTML element) (last v)))
    (when (map? (second v))
      (update-attributes element (merge {"id" (name id)} (second v))))
    element))

(defn update-header
  "Update page header, match hash map key to document id in this format
  {:node-id [:node-name {:attrb1 \"value1\" :attrb2 \"value 2\"}]}"
  [hm-values]
  (mapv (fn [[k v]]
          (let [element (.getElementById js/document (name k))]
            (if element
              (update-attributes element (second v))
              (do
                (.appendChild (aget (.getElementsByTagName js/document "head") 0)
                              (create-element k v))))))
        (partition 2 hm-values)))

(defn reagent-render [hiccup]
  ;(rc/render root-header [:meta "property" "og:image"])
  (rc/render root-element
             hiccup))

(defn write-clipboaard
  "Copy to clipboard the tab has to be focused when triggered"
  [text]
  (-> (js/Promise.resolve (.writeText (.-clipboard js/navigator) text))
      (.then #(js/console.log %))
      (.catch #(js/console.log %))
      (.finally #(js/console.log "cleanup"))))

;(.ErrorBoundary Sentry)

(defn initSentry
  "https://dev.to/frankapiyo/logging-readable-clojurescript-cljs-errors-to-sentry-2ob4"
  [dsn]
  (try
    (.init Sentry #js {:dsn dsn
                       :environment environment
                       :release "dev"
                       :integrations [(BrowserTracing.)]
                       :traceSampleRate 1.0})
    (catch js/Error _
      (.log js/console "Sentry not available disable adblocker."))))

(defn sendSentry [msg]
  (when Sentry
    (.captureException Sentry (js/Error. msg))))

#_(defmacro sentry-transaction
    [name & body]
    (let [transaction (.startTransaction Sentry #js {:name name})]
      body
      (.finish transaction)))

;(macroexpand '(sentry-transaction "test" (prn "one") (prn "two")))

#_(defn sentry-start-transaction [name callback]
    (let [transaction (.startTransaction Sentry #js {:name name})
          result (callback)]
      (tap> "transaction")
      (.finish transaction)
      result))
#_(-> (js/Promise.resolve 42)
      (.then #(js/console.log %))
      (.catch #(js/console.log %))
      (.finally #(js/console.log "cleanup")))
;  (.startTransaction Sentry #js { name: name }))

(defn page-schedule [{:keys [path] :as route}]
  (let [search (r/atom "")]
    (fn []
      [:<>
       [:div.w-100
        [ui-calendar "test" (placed-plant-eids)]
        #_[ui-search search]]])))

(defn default-page []
  [:div.flex.flex-wrap.justify-around
   [:div.w-40.ma2 [tile {:title "Diagram" :link (rfe/href :diagrams)}]]
   [:div.w-40.ma2 [tile {:title "Add plant" :link (rfe/href :plant-add)}]]
   [:div.w-40.ma2 [tile {:title "Create list" :link (rfe/href :plant-lists)}]]
   [:div.w-40.ma2 [tile {:title "Search plants" :link (rfe/href :plant-search)}]]
   [:div.w-40.ma2 [tile {:title "Schedule" :link (rfe/href :diagrams)}]]])

(defn ^:dev/after-load ^:after-load render-page-route  []
  (let [current-parameters (r/cursor site-page [:current-route :parameters])
        current-path (r/cursor site-page [:current-route :parameters :path])
        current-page (r/cursor site-page [:current-route :data :name])
        current-view (r/cursor site-page [:current-route :data :view])]
    (fn render-page-route  []
      (case @current-page
        [layout @current-view @current-parameters @current-page]))))

(defn extract-tags [text]
  (->> (str/split text #_(:filetags %) #":")
       (reduce (fn [m a] (concat m [:tag a])) [])
       vec))

(defn register-service-worker []
  (when (.-serviceWorker js/navigator)
    (-> (js/navigator.serviceWorker.register "/js-worker/web-worker.js")
        (.then #(.log js/console (str "Service worker registered " %)))
        (.catch #(.log js/console (str "Service worker failed " %))))))

(defn global-keys [key]
  (prn "global " (-> @site-state :global-events))
  (when (-> @site-state :global-events)
    (case key
      "Space" (m/select-plant-modal)
      " " (m/select-plant-modal)
      "d" (toggle-debug)
      "s" (set-mode :select nil)
      "m" (set-mode :move nil)
      "r" (set-mode :remove nil)
      "Escape" (do (reset-mouse) (hide-modal))
      "Delete" (rm-ob (-> @app-state :selected :eid))
      "ArrowUp" (pan-canvas 0 1)
      "ArrowDown" (pan-canvas 0 -1)
      "ArrowLeft" (pan-canvas 1 0)
      "ArrowRight" (pan-canvas -1 0)
      nil)))

(defn register-disable-scroll []
  ;; Probably obsolete now.
  (.addEventListener (.-body js/document) "touchstart" (fn [e]
                                                         (prn "touch start body")
                                                         (when (:diagram-focus @site-state)
                                                           (prn (.-target e))
                                                           (.preventDefault e))) #js {:passive false})
  (.addEventListener (.-body js/document) "touchend" (fn [e]
                                                       (when (:diagram-focus @site-state)
                                                         (prn (.-target e))
                                                         (.preventDefault e))) #js {:passive false})
  (.addEventListener (.-body js/document) "touchmove" (fn [e]
                                                        (.preventDefault e)
                                                        (.stopPropagation e)
                                                        (prn (:diagram-focus @site-state))
                                                        (when (true? (:diagram-focus @site-state))
                                                          (prn "move")
                                                          (prn (.-pageYOffset js/window))
                                                          (prn (.-target e))
                                                          (.preventDefault e)
                                                          (.stopPropagation e);
                                        ;(.scrollTo js/window 0 0)
                                                          )
                                                        false) #js {:passive false}))

(defn register-global-events [pages]
  (.addEventListener
   js/document
   "keydown"
   (fn [evt]
     (when (not= "INPUT" (-> js/document .-activeElement .-tagName))
       ((get pages (-> @site-page :current-route :data :name) :default) (.-key evt)))
     #_(when (polyculture?)
         (when (some? (polyculture-global-keys (.-key evt)))
           (.preventDefault evt)))
     #_(when (diagram?)
         (when (some? (global-keys (.-key evt)))
           (.preventDefault evt))))))

(defn error-boundary-component [comp]
  (r/create-class
   {:constructor (fn [this props]
                   (set! (.-state this) #js {:error nil}))
    :component-did-catch (fn [this e info]
                           (.captureException Sentry e))
    :get-derived-state-from-error (fn [error]
                                    (prn "derived error ")
                                    (prn error)
                                    #js {:error error})
    :render (fn [this]
              (r/as-element
               (if-let [error (.. this -state -error)]
                 [layout
                  [:div (str error)]
                  [:div
                   "Something went wrong."
                   [:button {:on-click #(.setState this #js {:error nil})} "Try again"]]]
                 [comp])))}))

(defn ^:dev/after-load render []
  (reagent-render
   [error-boundary-component
    render-page-route]))

(defn change-document-head [match]
  (let [headers-fn (get-in match [:data :head]
                  (fn [_] 
                    {:mh-head [:title "The Plantscape - Garden design"]
                     :mh-og-title [:meta {"property" "og:title" "content" "The Plantscape - Garden design"}]
                     :mh-og-url [:meta {"property" "og:url" "content" "https://theplantscape.com"}]
                     :mh-og-type [:meta {"property" "og:type" "content" "website"}]
                     :mh-og-description [:meta {"property" "og:description" "content" "test title"}]
                     :mh-og-image [:meta {"property" "og:image" "content" "https://img.theplantscape.com/api/image/pf/default.png?p=large"}]
                     :mh-description [:meta {"name" "description"}]
                     :mh-keywords [:meta {"name" "keywords"}]
                     :mh-robots [:meta {"name" "robots"} "index, follow"]})) ]
    (doseq [header (headers-fn (-> match :path-params))]
      (update-header header)))
  )

(defn #_:dev/after-load setup-routes
  "Needs to be part of hot reload life cycle"
  []
  (rfe/start!
   route/router
   (fn [match]
     (swap! site-page assoc :current-route match)
     #_(update-meta)
     (when (some? (-> match :data :state))
       (swap! site-page assoc :current-state (-> match :data :state))
       ;; update page header when route changes
       (change-document-head match)
       ((-> match :data :state) (-> match :path-params))))
   ;; set to false to enable HistoryAPI
   {:use-fragment false #_(if (= environment "development")  true false)}))

(defn geo-position-error [position]
  (when (-> @site-state :compass :rotation)

    (swap! site-state assoc-in [:current :geo] {:error  (.. position -code)})
    (swap! site-state assoc :location [0 0])
    #_(swap! site-state assoc-in [:current :geo-position] [0 0])))

(defn geo-position [position]
  (when (-> @site-state :compass :enabled)
    (when (instance? js/GeolocationPosition position)
      (when (and (not= (.. position -coords -latitude) (-> @site-state :location first))
                 (not= (.. position -coords -longitude) (-> @site-state :location second)))
        (swap! site-state assoc :location [(.. position -coords -latitude)
                                           (.. position -coords -longitude)]))
      ;; (prn "geo coords " [(.. position -coords -latitude) (.. position -coords -longitude)])
      ;; (prn (get-in @app-state [:diagram :settings :values :diagram.settings/geo-location ] [51.2701363 0.552638]))
      ;; (prn "distance lat long")
      #_(prn (distance-lat-long
              (get-in @app-state [:diagram :settings :values :diagram.settings/geo-location])
              (get-in @site-state [:location])
              :feet))
      ;;(.dir js/console position)
      ;;(prn (str "GPD accuracy = " (.. position -coords -accuracy)))
      (swap! site-state assoc-in [:current :geo]
             {:position (distance-lat-long
                         (get-in @app-state [:diagram :settings :values :diagram.settings/geo-location])
                         (get-in @site-state [:location])
                         :feet)
              :accuracy
              (.. position -coords -accuracy)})
      #_(swap! site-state assoc-in [:current :geo :position]
               (distance-lat-long
                (get-in @app-state [:diagram :settings :values :diagram.settings/geo-location])
                (get-in @site-state [:location])
                                        ;(.. position -coords -latitude)
                :feet))
      #_(prn (-> @site-state :current :geo-position)))))

(defn init []
  ;(def p (p/open))
  (monitor-start)
  (initSentry "https://71e1403dbc124c1e9486229649f23e8b@o1136827.ingest.sentry.io/6244903")
  (.init logrocket "dmqwol/theplantery")
  (setup-routes)
  (swap! site-state assoc :auth
         (edn/read-string
          (b/store-get-item "auth")))

  (register-service-worker)
  ;(register-disable-scroll)
  (register-global-events
   {:default global-keys
    :diagram global-keys
    :polyculture polyculture-global-keys})

  (prn "position")
  (b/register-gps-data-watch geo-position geo-position-error)

  (when (.-DeviceOrientationEvent js/window)
    (.addEventListener
     js/window
     "deviceorientation"
     (fn [evt]
       (when (-> @site-state :compass :enabled true?)
         (swap! site-state assoc-in [:compass :rotation]
                (if (.-webkitCompassHeading evt)
                  (.-webkitCompassHeading evt)
                  (.-alpha evt))))) true))

  ;; Test if api is available
  #_(db-connected
     #(swap! site-state assoc :online true)
     #(swap! site-state assoc :online false))
  (register-queries)
  ;; TODO remove once remote loading works correctly
  ;;(db-local-store/restore-database db/diag)
  (insert-diagram-data)
  ;(insert-objects (map #(assoc % :tool/usage 0) actions))

  (render))

;;(defonce ^:export start (init))
